import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["ConfigProvider"], { "scroll-body": false }, {
        default: _withCtx(() => [
            _createVNode($setup["MenuRoot"], {
                modal: false,
                open: $setup.open,
                "onUpdate:open": $setup.onOpenChange
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["MenuTrigger"], {
                        onPointerdown: $setup.onTriggerPointerDown,
                        onPointerenter: $setup.onTriggerPointerEnter,
                        onPointerleave: $setup.onTriggerPointerLeave
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "trigger")
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["onPointerdown", "onPointerenter", "onPointerleave"]),
                    _createVNode($setup["MenuContent"], {
                        align: $props.align,
                        class: _normalizeClass($setup.props.class),
                        "side-offset": $props.sideOffset,
                        side: $props.side,
                        "collision-padding": $props.collisionPadding,
                        sticky: $props.sticky,
                        "prioritize-position": $props.prioritizePosition,
                        "should-keep-focus": $props.shouldKeepFocus,
                        onCloseAutoFocus: $setup.onCloseAutoFocus,
                        onOpenAutoFocus: $setup.onOpenAutoFocus,
                        onPointerenter: $setup.onContentPointerEnter,
                        onPointerleave: $setup.onContentPointerLeave
                    }, {
                        default: _withCtx(() => [
                            ($props.label)
                                ? (_openBlock(), _createBlock($setup["MenuLabel"], { key: 0 }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($props.label), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, i) => {
                                return (_openBlock(), _createBlock($setup["MenuItem"], {
                                    key: i,
                                    disabled: item.disabled,
                                    onSelect: ($event) => (item.onClick?.())
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onSelect"]));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["align", "class", "side-offset", "side", "collision-padding", "sticky", "prioritize-position", "should-keep-focus", "onCloseAutoFocus", "onPointerenter", "onPointerleave"])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["open", "onUpdate:open"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
